import React from 'react'
import { Box } from '../../atoms/AppBox'
import AppInput from 'components/atoms/AppInput/AppInput'
import AppButton from 'components/atoms/AppButton/AppButton'
import IconAdd from '../../../assets/plus.png'
import { useNavigate } from 'react-router-dom'

interface Props {
    children: React.ReactNode
    templateName?: string
    buttonDisabled?: boolean
    onAddRule?: () => void
    onNameChange?: (name: string) => void
    onCreateTemplate?: () => void
    onEditTemplate?: () => void
}

const PatternForm = ({
    children,
    onAddRule,
    onCreateTemplate,
    onNameChange,
    templateName,
    onEditTemplate,
    buttonDisabled,
}: Props) => {
    const navigate = useNavigate()
    return (
        <Box>
            <div>
                <h2 className="font-semibold mb-4 text-xl text-[#070A13] leading-[24px]">
                    Nombre de la Plantilla
                </h2>
                <AppInput
                    placeholder="Nombre de la plantilla"
                    value={templateName ?? ''}
                    onChange={(e) => onNameChange?.(e.target.value)}
                />
                <div>
                    <h2 className="font-semibold mt-8 text-xl text-[#070A13] leading-[24px]">
                        Reglas
                    </h2>
                    <div className="overflow-y-auto pr-2">{children}</div>
                </div>
                <div className="mt-6">
                    <AppButton
                        title="Agregar Regla"
                        onClick={onAddRule}
                        state="ghost"
                        size="md"
                        className="font-normal"
                        icon={
                            <img src={IconAdd} alt="add" className="w-4 h-4" />
                        }
                    />
                </div>
            </div>
            <hr className="mt-[50px]" />
            <div className="flex justify-end gap-3 mt-6">
                <AppButton
                    title="Descartar"
                    onClick={() => {
                        navigate('/templates')
                    }}
                    state="ghost"
                    size="md"
                    className="font-bold"
                />
                <AppButton
                    title={
                        onEditTemplate ? 'Guardar Cambios' : 'Crear Plantilla'
                    }
                    onClick={onEditTemplate ? onEditTemplate : onCreateTemplate}
                    disabled={buttonDisabled}
                    state="primary"
                    className="bg-[#00B894] text-white font-semibold"
                />
            </div>
        </Box>
    )
}

PatternForm.displayName = 'PatternForm'

export default PatternForm
